import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import reportWebVitals from './reportWebVitals';
import 'typeface-roboto';
import { ThemeProvider } from '@material-ui/core';
import theme from './common/utils/theme';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
  RouteProps
} from 'react-router-dom';

import Login from './login-page/LoginPage';
import { ROUTE } from './common/utils/route';
import HomePage1 from './front-page/FrontPage';
import FrontPage from './front-page/FrontPage';
import { getUser } from './common-package/user';

interface ProtectedRouteProps extends RouteProps {
  element: JSX.Element;
}
const ProtectedRoute: React.FunctionComponent<ProtectedRouteProps> = ({
  element
}) => {
  let isAuthenticated = getUser() !== null;

  return (
    <Route
      render={props =>
        isAuthenticated ? (
          element
        ) : (
          <Redirect
            to={{
              pathname: ROUTE.LOGIN,
              state: { from: props.location }
            }}
          />
        )
      }
    />
  );
};

const Index = () => {
  return (
    <>
      <Switch>
        <Route exact path={ROUTE.HOME_PAGE}>
          <FrontPage />
        </Route>
        <ProtectedRoute
          exact
          path={ROUTE.HOME_PAGE_1}
          element={<HomePage1 />}
        />
        <Route path={ROUTE.LOGIN}>
          <Login />
        </Route>
      </Switch>
    </>
  );
};
ReactDOM.render(
  <ThemeProvider theme={theme}>
    <Router>
      <Index />
    </Router>
  </ThemeProvider>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
